var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _circle, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLightTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 395,
    viewBox: "0 0 542 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509 32H73.8956C38.607 32 10 60.607 10 95.8956V95.8956C10 131.184 38.607 159.791 73.8956 159.791H421.076",
    stroke: "#315A5E",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.023 229.971H76.5143C39.7795 229.971 10 259.751 10 296.486V296.486C10 333.22 39.7794 363 76.5143 363H510",
    stroke: "#315A5E",
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96.9431H401.014C455.683 96.9431 500 141.261 500 195.929V195.929C500 250.597 455.683 294.915 401.014 294.915H90",
    stroke: "#315A5E",
    strokeWidth: 20
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 510,
    cy: 31.5,
    rx: 21.5,
    ry: 22,
    transform: "rotate(90 510 31.5)",
    fill: "white",
    stroke: "#ED6A5A",
    strokeWidth: 20
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 510,
    cy: 363,
    rx: 22,
    ry: 22,
    transform: "rotate(90 510 363)",
    fill: "white",
    stroke: "#ED6A5A",
    strokeWidth: 20
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 96,
    rx: 22,
    ry: 22,
    transform: "rotate(90 93 96)",
    fill: "white",
    stroke: "#ED6A5A",
    strokeWidth: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 160,
    r: 21,
    transform: "rotate(90 408 160)",
    fill: "white",
    stroke: "#ED6A5A",
    strokeWidth: 20
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 408,
    cy: 230,
    rx: 22,
    ry: 21,
    transform: "rotate(90 408 230)",
    fill: "white",
    stroke: "#ED6A5A",
    strokeWidth: 20
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 296,
    rx: 22,
    ry: 22,
    transform: "rotate(90 93 296)",
    fill: "white",
    stroke: "#ED6A5A",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightTheme);
export default __webpack_public_path__ + "static/media/logo-light-theme.8087ebe977d09871e142b2b860b233fe.svg";
export { ForwardRef as ReactComponent };